import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="flex items-center flex-wrap gap-1.5 text-sm text-foreground-500" aria-label="面包屑导航">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-1.5">
            {item.to && !isLast ? (
              <Link to={item.to} className="hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? "text-foreground-900 font-medium" : ""}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-base text-foreground-400" />}
          </span>
        );
      })}
    </nav>
  );
}